import { brand } from "@/brandVariables/getBandVariables";
import { Flex, Text } from "@radix-ui/themes";

import { ReactComponent as StopWatchElgiganten } from "../assets/Timer icon elgiganten racing.svg";
import { ReactComponent as StopWatchWhite } from "../../../assets/stopwatch_white.svg";
import { ReactComponent as StopWatch } from "../../../assets/stopwatch.svg";

export const TimerComp = ({ time, justTimer = false }) => {
  const isTimerOn0 = time === "00:00:00";
  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";

  const stopWatchToRender = () => {
    if (brand.client === "elgiganten-9u2oj") {
      return <StopWatchElgiganten />;
    }
    if (brand.client === "LEGOF1") {
      return <StopWatchWhite />;
    } else {
      return <StopWatch />;
    }
  };

  return (
    <Flex
      className="timer_comp"
      align={"center"}
      justify={"end"}
      direction={"row"}
      height={"fit-content"}
      mb={"2"}
    >
      {!isTimerOn0 && !justTimer && <Text as="p">Challenge ends in</Text>}
      {!isTimerOn0 && (
        <Flex
          m={"0"}
          maxWidth={"1.5rem"}
          mr={"1"}
          ml={"3"}
          align={"end"}
          justify={"center"}
          className="stopwatch"
          width={"100%"}
        >
          {stopWatchToRender()}
        </Flex>
      )}

      {isTimerOn0 ? (
        <Text size={"6"} className={`${isElgiganten}`}>
          Processing...
        </Text>
      ) : (
        <Text size={"7"} className={`${isElgiganten}`}>
          {time || "--:--:--"}{" "}
        </Text>
      )}
    </Flex>
  );
};
